<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    width="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <button v-bind="attrs" v-on="on" tabindex="0" class="settings-button">
        <i class="mdi mdi-checkbox-blank"></i>
        <span>{{ hubbdata.settings.title }}</span>
      </button>
    </template>

    <v-card class="settings">
      <v-toolbar dark color="primary" class="settings__toolbar">
        <v-btn icon dark @click="dialog = false" class="settings__close">
          <v-icon>mdi-close</v-icon>
          <span class="sr-only">{{ hubbdata.settings.text.close }}</span>
        </v-btn>
        <v-toolbar-title>{{ hubbdata.settings.title }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-container>
        <v-row>
          <v-col
            style="flex-direction: column; width: 100%; padding-top: 30px; flex-flow: wrap;"
            class="settings_page-title"
          >
            <v-list-item-title>
              <label class="d-block" for="fonts" id="languageSelect">{{
                hubbdata.settings.text.changedefault
              }}</label>
            </v-list-item-title>

            <v-switch
              v-model="openDyslexic"
              name="fonts"
              class="d-block w-100"
              width="100%"
              :label="`OpenDyslexic`"
              @change="updateFont(openDyslexic)"
              solo
            ></v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            class="settings_language-selector"
          >
            <v-list-item-title>
              <label style="" for="languages" id="languageSelect">{{
                hubbdata.settings.text.languages
              }}</label>
            </v-list-item-title>

            <v-select
              v-model="selectedLang"
              :items="langs"
              style="padding-top: 10px;"
              id="languages"
              item-text="name"
              item-value="code"
              @change="updateLang(selectedLang)"
              solo
              hide-details
            >
            </v-select>
          </v-col>
        </v-row>

        <v-alert
          close-text="Close Alert"
          color="#dee0e2"
          rounded="false"
          dismissible
          icon="mdi-alert-circle"
          class="banner settings_page-alerts"
          light
          @input="DismissFontAlert()"
          v-if="fontAlert"
        >
          <span v-if="openDyslexic">{{ hubbdata.settings.text.textopen }}</span>
          <span v-else>{{ hubbdata.settings.text.textdefault }}</span>
        </v-alert>
        <v-alert
          close-text="Close Alert"
          color="#dee0e2"
          rounded="false"
          dismissible
          icon="mdi-alert-circle"
          class="banner settings_page-alerts"
          light
          @input="DismissAlert()"
          v-if="alert"
        >
          {{ hubbdata.settings.text.languageset }} {{ currentLang }}
        </v-alert>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import hubbdata from "@/hubbdata";

export default {
  name: "Settings",
  data: () => ({
    drawer: false,
    selectedLang: localStorage.getItem("current_lang"),
    dialog: false,
    fontAlert: false,
    alert: false,
    openDyslexic: false,
    langs: [
      { name: "English", code: "en" },
      { name: "Albanian | Shqiptare", code: "sq" },
      { name: "Amharic | አማርኛ", code: "am" },
      { name: "Arabic | عربي", code: "ar" },
      { name: "Pashto | میل", code: "ps" },
      { name: "Persian | فارسی", code: "fa" },
      { name: "Tigrinya  | ትግርኛ", code: "ti" },
    ],
  }),

  mounted() {
    if (localStorage.getItem("enable_font_change") === "true") {
      this.openDyslexic = true;
    } else {
      this.openDyslexic = false;
    }

    /// listening for language change emit coming form Header.vue
    /// we're passing the 'language' and then setting is as a selected one
    this.$bus.$on("language-changed-from-header", (language) => {
      this.selectedLang = language;
    });
  },

  beforeDestroy() {
    // stop listening for the emit coming from Header.vue
    this.$bus.$off("language-changed-from-header");
  },

  methods: {
    updateLang(selectedLang) {
      hubbdata.dispatch("updateLang", selectedLang).then(() => {
        hubbdata.dispatch("initDB").then(() => {});
      });
      this.alert = true;
      // send a global emit back to Header.vue with the newly selected language
      this.$bus.emit("language-changed-from-settings-page", this.selectedLang);
    },
    updateFont(font) {
      localStorage.setItem("enable_font_change", font);
      hubbdata.dispatch("updateFont", font);
      this.fontAlert = true;
    },
    DismissAlert() {
      this.alert = false;
    },
    DismissFontAlert() {
      this.fontAlert = false;
    },
  },

  computed: {
    currentLang() {
      let dictionary = {
        en: "English",
        sq: "Albanian",
        am: "Amharic",
        ar: "Arabic",
        ps: "Pashto",
        fa: "Persian",
      };

      return dictionary[this.selectedLang];
    },
    hubbdata() {
      return hubbdata.getters.translations;
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-button {
  display: block;
  width: 100%;
  padding: 16px 8px;
  color: black;
  line-height: 1.2;
  text-align: left;
  text-transform: lowercase;

  &:focus {
    outline: 2px solid #000000;
  }

  i {
    color: $red;
  }
}

.settings {
 
  &__toolbar {
    height: auto !important;
    padding-top: var(--sat); 
  }

  &__close {

    &:focus {
      outline-color: black;
    }

    i {
      padding-right: 0;
    }
  }
}

.v-navigation-drawer__content {
  padding-top: 40px !important;
}

a:focus {
  outline: 2px solid $black;
}

a {
  text-decoration: none !important;
}

.v-alert {
  margin: 10px 0px 10px 10px !important;
  margin-left: 0px !important;
  width: 100%;
}

.v-list-item__title {
  font-size: 16px !important;
  text-align: left;
  line-height: 1.8em !important;
}

.users-list {
  padding-left: 0;
  display: flex;
  list-style: none;
  font-size: 11px;

  &__item {
    padding: 4px;
  }
}

.back-button {
  margin-right: 10px;
  text-transform: capitalize;
}

.banner {
  margin-top: 57px;
  font-size: 12px;
  text-align: center;
}

.sign-out {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.v-badge__badge {
  color: black !important;
}

.v-list-item__title a,
.v-list-item__title,
.v-input,
label {
  color: black !important;
  text-decoration: none !important;
  font-size: 15px;
  text-transform: lowercase;
  border-radius: 0;
}

.v-list-item--link {
  border-bottom: 1px solid black;
  border-radius: 0 !important;
  padding: 5px 8px !important;
}

label {
  color: #1d1d1d !important;
}

.label {
  margin: 10px !important;
}

i {
  color: $blue;
  font-size: 10px;
  padding-right: 10px;
}

.v-input {
  border-radius: 0px;
}

.settings_page-title,
.settings_language-selector {
  border: none !important;

  @media (min-width: 1020px) {
    max-width: 80%;
    margin: 0 auto !important;
  }
}

.settings_page-alerts {

  @media (min-width: 1020px) {
    max-width: 80%;
    margin: 10px auto !important;
  }
}
</style>

<style lang="scss">
.settings_language-selector {

  .v-input {
    text-transform: none !important;
  }

  &:focus-within .v-input__control {
    outline: 2px solid $black !important;
    outline-offset: 2px !important;
  }

  .v-select__selections {
    line-height: 20px;
  }
}
</style>
